import { Navigate, Route, Routes } from 'react-router-dom';

import { ConnectionsPage } from '@/admin/ConnectionsPage.js';
import { HistoryPage } from '@/admin/HistoryPage.js';
import { OAuthCompletePage } from '@/admin/OAuthCompletePage.js';
import { TargetsPage } from '@/admin/TargetsPage.js';
import { AppShell } from '@/components/AppShell.js';
import { HandshakeGate } from '@/components/HandshakeGate.js';
import { BrowsePage } from '@/experience/BrowsePage.js';
import { DistributePage } from '@/experience/DistributePage.js';
import { DistributionPage } from '@/experience/DistributionPage.js';
import { DistributionsPage } from '@/experience/DistributionsPage.js';

/**
 * Two route trees from one Pages project. Kadanza registers `/experience` as
 * the Experience page base URL and `/admin` as the Admin Console base URL, and
 * both mount behind the same handshake gate.
 */
export function App() {
  return (
    <Routes>
      {/* The OAuth popup has no host to shake hands with, so it stays outside the gate. */}
      <Route path="/oauth-complete" element={<OAuthCompletePage />} />
      <Route path="*" element={<GatedRoutes />} />
    </Routes>
  );
}

function GatedRoutes() {
  return (
    <HandshakeGate>
      <Routes>
        <Route path="/" element={<Navigate to="/experience" replace />} />

        <Route path="/experience" element={<AppShell title="Distribute creatives" scheme="dark" />}>
          <Route index element={<BrowsePage />} />
          <Route path="sources/:sourceId" element={<DistributePage />} />
          <Route path="distributions" element={<DistributionsPage />} />
          <Route path="distributions/:distributionId" element={<DistributionPage />} />
        </Route>

        <Route path="/admin" element={<AppShell title="Content Distribution" />}>
          <Route index element={<Navigate to="/admin/connections" replace />} />
          <Route path="connections" element={<ConnectionsPage />} />
          <Route path="targets" element={<TargetsPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="history/:distributionId" element={<DistributionPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/experience" replace />} />
      </Routes>
    </HandshakeGate>
  );
}
